import { SetStateAction, useContext, useEffect, useRef, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import SearchBar from '../../../common/search-bar/search-bar';

import FilterBar from '../../../common/filter-bar/filter-bar';
import ChecklistIcon from '@mui/icons-material/Checklist';
import LinkIcon from '@mui/icons-material/Link';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { DraftFunction, useImmer } from 'use-immer';
import {
  DoubleDate,
  DoubleDateMode,
  DoubleDateWithMode,
} from '../../../common/double-date-picker/double-date-picker.interfaces';
import DoubleDatePicker from '../../../common/double-date-picker/double-date-picker';
import BulkAction from '../../../common/bulk-action/bulk-action';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import axios from 'axios';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import InventoryIcon from '@mui/icons-material/Inventory';
import { buildQueryParams } from '../../../common/filter-bar/filter-bar.utils';

import { PaginationContext } from '../../../../contexts/pagination-context';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { IFilterOption } from '../../../common/filter-bar/types';
import GenericTable from '../../../common/generic-table/generic-table';
import { showWorkflow } from '../../../common/styles/workflow-display';
import { displayMoney } from '../../../../utils/money';
import { get_cod } from '../../../../utils/cod';
import { showDeliveryState } from '../../../common/styles/order-states.style';
import CopyLinkButton from '../../../common/copy-link-button/copy-link-button';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { displayLocation } from '../../../../utils/locations';
import { showPickupTaskChip } from '../../../common/styles/pickup-task.styles';
import PickupTaskDialog from '../../pickup-tasks/pickup-task-dialog';
import { GenericList } from '../../../common/generic-list/generic-list';
import { red } from '@mui/material/colors';
import { get_notes } from '../../../../utils/notes';
import ResponsiveOrdersListing, {
  relevant_fields,
} from '../../common/orders-listing';
import { OrdersFilterKeys } from '../../../common/filter-bar/keys-config';
import DeliveryBatchDialog from '../../delivery-tasks/delivery-task-dialog';
import { UserType } from '../../../../enums/users';
import CreateEntityDrawer from '../../../common/create-entity-drawer/create-entity-drawer';
import CreateOrderForm from '../create-order-form/create-order-form';
import { SortingByColumnState } from '../../../common/orders-listing-table/utils';
import DoubleDateOrdersFilter from '../../../common/double-date-orders-filter/double-date-orders-filter';
import { generateDateFilterQueryParam } from '../../../common/double-date-orders-filter/utils';
import FrozenOrdersButton from '../../../common/frozen-orders/frosted-button';
import FrozenOrdersButtonWithDialog from '../../../common/frozen-orders/frozen-orders-dialog';
import CriticalOrders from '../../../common/critical-orders-alert/critical-orders-alert';
import { useSnackBar } from '../../../../contexts/snackbar';
import { IQuickFilter } from '../../../../interfaces/common/quick-filters';
import { QuickFilterScope } from '../../../../enums/quick-filters';
import NewFeatureChip from '../../../common/new-feature-chip';
import { ApplyQuickFilter, UnapplyQuickFilter } from '../../../common/apply-quick-filters-manager/apply-quick-filters-manager';
import { DataResources, ResourceActionType, user_has_data_model_access, user_has_page_access } from '../../../../utils/permissions';
import { QrCode2 } from '@mui/icons-material';
import { useApiConfigWithBranch } from '../../../../hooks/use-api-config-with-branch';
import { useBranchFilter } from '../../../../contexts/branch-filter-context';
import BranchFilterSelector from '../../../common/branch-filter-selector/branch-filter-selector';

function OrdersListing() {
  const [ordersList, setOrdersList] = useState<OrderType[]>([]);
  const [ordersCount, setOrdersCount] = useState(0);
  const [incompleteOrdersOnly, setIncompleteOrdersOnly] = useState(false);
  const [includeFrozen, setIncludeFrozen] = useState(false);
  const [sorting, setSorting] = useState<SortingByColumnState>({
    column: 'creation_date',
    order: 'decreasing',
  });
  const {showMessage} = useSnackBar()
  const [hasCriticalOrders, setHasCriticalOrders] = useState(false)
  const [showScanWithFilterModal, setShowScanWithFilterModal] = useState(false)
  const [showCriticalOnly, setShowCriticalOnly] = useState(false)

  const [showingPickupTask, setShowingPickupTask] = useState<string | null>(
    null
  );
  const [showingDeliveryBatch, setShowingDeliveryBatch] = useState<
    string | null
  >(null);

  console.log(sorting);
  const [dateFilter, setDateFilter] = useState<DoubleDateWithMode>({
    startDate: null,
    endDate: null,
    mode: DoubleDateMode.CREATION_DATE,
  });

  const [queryEndpointToFetch, setQueryEndpointToFetch] = useState<string>();

  const { color } = useContext(OrgSettingsContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [selectedOrders, updateSelectedOrders] = useImmer<
    Map<string, OrderType>
  >(new Map());

  const resetSelectionState = () => {
    updateSelectedOrders((selectedOrders) => {
      selectedOrders.clear();
    });
  };

  const { user } = useContext(AuthContext);
  const { config, selectedBranch, branchKey } = useApiConfigWithBranch();
  const { showAllBranches } = useBranchFilter();

  const { paginationConfig, setPaginationConfig } =
    useContext(PaginationContext);

  console.log('pagination config = ', paginationConfig);
  const totalSelected = selectedOrders.size;

  const searchOptions = ['Order_Id', 'Ref_Number'];

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: paginationConfig.rowsPerPage,
    searchColumn: 'Order_Id',
    searchValue: '',
    searchOperation: 'equals',
  });

  const [filters, setFilters] = useState<IFilterOption[]>([]);

  useEffect(() => {
    let endpoint = `${API_ENDPOINT}/api/v1/orders/?page=${controller.page + 1}&page_size=${controller.rowsPerPage}&fields=${relevant_fields.join(',')}`;

      if (controller.searchColumn !== '' && controller.searchValue !== '') {
        endpoint += `&${controller.searchColumn.toLowerCase()}__${controller.searchOperation}=${encodeURIComponent(controller.searchValue)}`;
      }

      const filterQueryParams = buildQueryParams(filters);
      endpoint += `${filterQueryParams}`;
      endpoint += `&${generateDateFilterQueryParam(dateFilter)}`;
      endpoint += `&sort_by_${sorting.order}=${encodeURIComponent(sorting.column)}`;

      if (showCriticalOnly) {
        endpoint += `&incomplete_critical_only=true`
      }

      if (incompleteOrdersOnly) {
        endpoint += `&incomplete_only=true`;
      }

      if (includeFrozen) {
        endpoint += `&include_frozen=true`;
      }

      if (showAllBranches) {
        endpoint += `&all_branches=true`;
      }

      setQueryEndpointToFetch(endpoint)

      console.log("Endpoint to fetch = ", endpoint)

  }, [controller, dateFilter, filters, sorting, incompleteOrdersOnly, includeFrozen, showCriticalOnly, showAllBranches, branchKey]);


  useEffect(() => {

    if (!queryEndpointToFetch) return 

    let response: any;
    const abortController = new AbortController();
    const signal = abortController.signal;
    const getData = async () => {
      
      const endpoint = queryEndpointToFetch
      setIsLoading(true);
      
      try {
        response = await axios.get<{ count: number; results: OrderType[] }>(
          endpoint,
          { ...config, signal }
        );
        setOrdersList(response.data.results);
        setOrdersCount(response.data.count);
      } catch (error: any) {
         if (axios.isCancel(error) || error.name === 'CanceledError') {
          console.log('Request canceled');
          return; // Exit without setting isLoading to false
        }
        showMessage("Failed to load orders", 'error')
        console.log(error)
      }
      setIsLoading(false);
    };
    getData();
    console.log(response);
    return () => {
      abortController.abort();
    }
  }, [queryEndpointToFetch, branchKey]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPaginationConfig({ ...paginationConfig, rowsPerPage: newRowsPerPage });
    setController({
      ...controller,
      rowsPerPage: newRowsPerPage,
      page: 0,
    });
  };

  const searchQueryAction = (
    column: string,
    value: string,
    operation: string
  ) => {
    setController({
      ...controller,
      page: 0,
      searchColumn: column,
      searchValue: value,
      searchOperation: operation,
    });
  };

  const resetPaginationControls = () => {
    setController({
      ...controller,
      page: 0,
    });
  };
  const filterQueryAction = (filters: IFilterOption[]) => {
    resetPaginationControls();
    setFilters(filters);
    resetSelectionState();
  };

  const dateFilterAction = (dateFilterValue: DoubleDateWithMode) => {
    resetPaginationControls();
    setDateFilter(dateFilterValue);
  };

  const resetAll = () => {
    resetPaginationControls();
    resetSelectionState();
  };

  const canCreateOrder = user_has_data_model_access(user, DataResources.ORDER, ResourceActionType.CREATE);

  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 1 }}
        >
          Orders
          <br />
          <FrozenOrdersButtonWithDialog />
        </Typography>

        <BranchFilterSelector />

        <Box mb={6} display={"flex"} justifyContent={"center"} width={"100%"} flexDirection={"column"} alignContent={"center"} alignItems={"center"}>
         
             <CriticalOrders onCriticalOrdersExists={()=>setHasCriticalOrders(true)}  />

               <Box display={"flex"} justifyContent={"center"} width={"100%"} mb={2} alignItems={"center"} >
         
             {
                hasCriticalOrders && <>
                   <Switch
                      checked={showCriticalOnly}
                      onChange={(e) => setShowCriticalOnly(!showCriticalOnly)}
                    />{' '}
                      <span style={{color: "black"}}> <b>Show critical orders</b>  ⚠️</span> 
                    <br />
                
                </>
              }
            
           
        </Box>

            
           
        </Box>

       

        

        <Grid container spacing={2}>
          <Grid xs={4}></Grid>
          <Grid xs={4}></Grid>
          <Grid xs={4} sx={{ textAlign: 'right' }}>
            <CreateEntityDrawer disabled={!canCreateOrder}>
              <CreateOrderForm
                onSuccess={(o) => {
                  if (filters.length === 0)
                    setOrdersList([
                      o,
                      ...ordersList.slice(
                        0,
                        Math.max(0, ordersList.length - 1)
                      ),
                    ]);
                }}
              />
            </CreateEntityDrawer>
          </Grid>
          <Grid xs={12}>
            <Box>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Box>
                    <Typography
                    variant="h5"
                    component="h5"
                    sx={{ textAlign: 'center', mt: 1, mb: 1 }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }}
                    >
                      <ManageSearchIcon fontSize="large" color="primary" />
                      <span>
                        <b>Search and Filter Controls</b>
                      </span>
                    </div>
                  </Typography>
                  </Box>
                  
                </AccordionSummary>
                <br />
                  
                <AccordionDetails>
                  <SearchBar
                    searchOptions={searchOptions}
                    searchQueryAction={searchQueryAction}
                  />
                  <br />

                  <DoubleDateOrdersFilter dateFilterAction={dateFilterAction} />
                  <br />
                  <FilterBar
                    filterQueryAction={filterQueryAction}
                    currentlySelectedFilters={filters}
                    filterKeys={OrdersFilterKeys('organisation')}
                    quickFiltersScope={QuickFilterScope.ORDER}
                  />
                </AccordionDetails>
              </Accordion>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 10,
                  marginLeft: 10,
                }}
              >
                <Chip
                  icon={<ChecklistIcon />}
                  color="primary"
                  label={`Selected ${totalSelected}/${ordersCount}`}
                  variant={
                    totalSelected === ordersCount && totalSelected > 0
                      ? 'filled'
                      : 'outlined'
                  }
                />

                <BulkAction
                  selectedOrders={selectedOrders}
                  bulkEndpoint={`${API_ENDPOINT}/api/org/orders/bulk-update/`}
                  refetchOrders={resetAll}
                />
              </div>

              
              <Switch
                checked={incompleteOrdersOnly}
                onChange={(e) => setIncompleteOrdersOnly(!incompleteOrdersOnly)}
              />{' '}
              Incomplete orders only
              <br />
               <Switch
                checked={includeFrozen}
                onChange={(e) => setIncludeFrozen(!includeFrozen)}
              />{' '}
                Include Frozen Orders
              <br />
              <ResponsiveOrdersListing
                ordersList={ordersList}
                selectedOrders={selectedOrders}
                updateSelectedOrders={updateSelectedOrders}
                isLoading={isLoading}
                sorting={sorting}
                setSorting={setSorting}
                applyQuickFilter={(quickFilter: IQuickFilter | null) => ApplyQuickFilter(quickFilter, filters, setFilters)}
                sourceView="orders-listing"
              />
              <TablePagination
                component="div"
                onPageChange={handlePageChange}
                page={controller.page}
                count={ordersCount}
                rowsPerPage={controller.rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 250, 500, 1000]}
                labelRowsPerPage=""
                style={{ overflow: 'visible' }}
              />
              {showingPickupTask && (
                <PickupTaskDialog
                  onClose={() => setShowingPickupTask(null)}
                  taskID={showingPickupTask}
                />
              )}
              {showingDeliveryBatch && (
                <DeliveryBatchDialog
                  onClose={() => setShowingDeliveryBatch(null)}
                  taskID={showingDeliveryBatch}
                />
              )}
            </Box>
            
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default OrdersListing;
